import { createAction } from 'redux-actions';

import { RefundInfoFragment } from '@websky/graphql';

export const SET_REFUND_INFO = 'REFUND/SET_REFUND_INFO ';

export const setRefundInfo = createAction<RefundInfoFragment>(SET_REFUND_INFO);

export type SetRefundInfoAction = ReturnType<typeof setRefundInfo>;

export type ActionRefundInfoTypes = SetRefundInfoAction;
